import React from 'react';
import styled from 'styled-components';
import ListPanel from '@/components/ListPanel';
import SvgIcon from '@/components/SvgIcon';
import BuriedPermWrapper from '@/components/BuriedWrapper/BuriedPermWrapper';
import Body from './Body';

export default function ResourceHost() {
  return (
    <Root
      header='主机资源'
      tip='部署集群的虚拟机/物理机资源， 需要proxy可以通过ssh进行访问以及用户具有sudo权限。'
      operators={
        <BuriedPermWrapper
          resource='pulsar:resource:hosts:web'
          eventId='RESOURCE_DETAIL_HOST_TERMINAL_CLICK'
        >
          <BigButton target='_blank' href='/maintenance/resource/host/webssh'>
            <SvgIcon type='terminal' style={{ marginRight: 5 }} />
            终端
          </BigButton>
        </BuriedPermWrapper>
      }
    >
      <Body />
    </Root>
  );
}

const Root = styled(ListPanel)`
  .shadow-card-body {
    padding: 0;
  }
`;

const BigButton = styled.a`
  cursor: pointer;
  padding: 0 23px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 6px;
  text-decoration: none;
  font: var(--td-font-body-medium);
  color: var(--td-font-gray-1);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1), 0px 1px 2px -1px rgba(0, 0, 0, 0.1);
`;
